<template>
  <div class="pageContainer targetPage flexCloumn">
    <el-row class="searchBar flexBetween" style="flex-wrap: wrap;width:100%">
      <div class="flexStart flex_1" style="flex-wrap:wrap;">
        <span>搜索关键字：</span>
        <el-input v-model="searchForm.keyword" size="small" placeholder="请输入" clearable style="max-width: 200px;" />
        <el-select v-model="searchForm.project_id" size="small" placeholder="选择体育项目" clearable
          style="margin-left: 10px;">
          <el-option v-for="(item,index) in sportProjects" :label="item.project_name" :value="item.id"
            :key="index"></el-option>
        </el-select>
        <el-button size="small" icon="el-icon-search" type="primary" style="margin-left: 10px;"
          @click="getList">查询</el-button>

        <div style="float:right">
          <el-button size="small" icon="el-icon-plus" type="primary" plain style="margin-left: 10px;"
            @click="handleAdd">新增
          </el-button>
        </div>
      </div>
    </el-row>
    <div class="dividerBar"></div>
    <el-table v-tableFit :data="tableData" height="100%" size="small" stripe border
      style="width:fit-content;width:100%;">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="team_name" label="队伍名称" align="center"></el-table-column>
      <el-table-column prop="team_desc" label="队伍描述" align="center"></el-table-column>
      <el-table-column prop="leader_name" label="队长" align="center"></el-table-column>
      <el-table-column prop="status" label="队伍状态" align="center">
        <template slot-scope="scope">
          <el-tag size="small" type="success" v-if="scope.row.status == 1">正常</el-tag>
          <el-tag size="small" type="info" v-if="scope.row.status == 0">解散</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="project_name" label="体育项目" align="center"></el-table-column>
      <el-table-column fixed="right" label="操作" width="250" align="center">
        <template slot-scope="scope">
          <el-popconfirm width="250" confirmButtonText='确定' cancelButtonText='取消' icon="el-icon-info" iconColor="red"
            @confirm="handleDel(scope.row)" placement="left" title="是否确定删除？">
            <el-tag class="pointer" slot="reference" type="danger" size="mini" style="margin-right: 10px;">删除</el-tag>
          </el-popconfirm>
          <el-tag class="pointer" @click="handleModify(scope.row)" type="primary" size="mini">修改</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handlePageChange" @size-change="handleSizeChange" :current-page="page.current_page"
      :page-size="page.per_page" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
      layout="total, prev, pager, next,sizes, jumper" :total="page.count">
    </el-pagination>

    <el-dialog title="添加/修改" :visible.sync="isShowModal" :close-on-click-modal="false" :destroy-on-close="true"
      custom-class="cus_dialog">
      <el-form :model="formData" ref="ruleform" label-width="120px"
        style="max-height: 500px;overflow-y: auto;min-height: 300px;">
        <el-form-item label="体育项目" prop="project_id" :rules="[{required:true,message:'请选择体育项目',trigger:'change'}]">
          <el-select v-model="formData.project_id" placeholder="请选择体育项目" @change="changeProject" style="width:50%">
            <el-option v-for="(item,index) in sportProjects" :label="item.project_name" :value="item.id"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="队伍名称" prop="team_name" :rules="[{required:true,message:'请输入队伍名称',trigger:'blur'}]">
          <el-input v-model.trim="formData.team_name" />
        </el-form-item>
        <el-form-item label="队伍描述">
          <el-input type="textarea" :autosize="{minRows:3}" maxlength="500" show-word-limit
            v-model.trim="formData.team_desc" />
        </el-form-item>
        <el-form-item label="选择队长" :rules="[{ required: true, message: '请选择队长', trigger: 'change' }]">
          <el-cascader v-model="formData.leader_id" :options="members"
            :props="{ value: 'id', label: 'name', emitPath: false}"></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" icon="el-icon-plus" plain
            @click="dialogVisible = true">添加成员</el-button>
          <div>
            <el-tag v-for="tag in selectedUsers" :key="tag.id" closable type="info" style="margin-right: 6px;">
              {{tag.username}}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item label="队伍状态">
          <el-radio-group v-model="formData.status">
            <el-radio :label="1">正常</el-radio>
            <el-radio :label="0">解散</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button size="small" type="default" @click="isShowModal = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitForm">保存</el-button>
      </template>
    </el-dialog>
    <DeptUser v-if="dialogVisible" :users="deptUsers" :odata="selectedUsers" :mult="true" @getUser="getUser" />
  </div>
</template>
<script>
import DeptUser from '../com/deptuser.vue'
import moment from "moment";
export default {
	name: 'dept',
	components: {DeptUser},
	data() {
		return {
			visible: false,
			isShowModal: false,
			isShowModalAuth: false,
			importTeacherShow: false,
			modalTitle: '添加',
      dialogVisible: false,
			showDeptroleManage: false,
			activeRoleID: "",
			formData: {
        status: 1,
        leader_id: ""
      },
			fgxz: [],
			activeName: 'CN',
			tableData: [],

			teacherList: [],
			editUser: {},
			deptId: null,
			editDeptRole: {},
			deptRoleList: [],
			isShowDeptRole: false,
			biye: 0,

			page: {
				count: 0,
				current_page: 1,
				per_page: 50,
				total_page: 0
			},
			searchForm: {

				ktype: "username",
				keyword: "",
				school_year: ""
			},
			multipleSelection: [],
			treeData: [],
			ckdTreeData: [],
			firstCascaderProps: {
				label: "name",
				children: "children",
			},
			defaultProps: {
				label: 'name',
				value: 'id',
				children: 'children',
				emitPath: false,
				checkStrictly: true
			},
			DataAuth: [],
			showTeacherInfo: false,
			teacher_id: 0,
			schoolYears: [],
      failedImportData: [],
      sportProjects: [],
      members: [],
      deptUsers: [],
      selectedUsers: [],
		}
	},

	mounted() {
    this.getSportsProject()
    this.getList()
	},
	methods: {
    getUser(value) {
      this.selectedUsers = value
    },
    getSportsProject() {
      this.$http.post('/api/sport_project_list',{page:1,pagesize:100}).then(res => {
        this.sportProjects = res.data.data
      })
    },
    getList() {
      this.$http.post('/api/teams_list',{
        page: this.page.current_page,
        pagesize: this.page.per_page ? this.page.per_page : 20,
        keyword: this.searchForm.keyword,
        project_id: this.searchForm.project_id,
        type: 2,
      }).then(res => {
        this.tableData = res.data.data
        this.page = res.data.page
      })
    },
    handleAdd() {
      this.isShowModal = true;
      this.formData = {
        status: 1,
        leader_id: ""
      }
      this.selectedUsers = []
      this.$nextTick(() => {
        this.$refs.ruleform.clearValidate()
      })
    },
		handleModify(row) {
			this.isShowModal = true;
			let formData = JSON.parse(JSON.stringify(row))
			if (formData.roles && formData.roles.length > 0) {
				formData.roles = formData.roles.map(e => { return e.role_id })
				let DataAuth = JSON.parse(JSON.stringify(row.roles))
				for (let item of DataAuth) {
					if (item.dept_data) {
						item.dept_data = item.dept_data.split(",")
					} else {
						item.dept_data = []
					}

				}
				if (DataAuth.length > 0) {
					this.activeRoleID = DataAuth[0].role_id + ""
				}
				this.DataAuth = DataAuth
			} else {
				this.DataAuth = []
			}

			this.formData = formData
      this.$http.post('/api/getMembers',{id:formData.id}).then(res => {
        this.selectedUsers = res.data
      })
			this.changeProject(formData.project_id,true)
		},
		handleDel(row) {
			this.$http.post("/api/teams_delete", {
				id: String(row.id)
			}).then(res => {
				this.$message.success('删除成功')
				this.getList();
			})
		},

		submitForm() {
			let params = {
				...this.formData
			}
      if (this.selectedUsers.length) {
        params.members = JSON.stringify(this.selectedUsers)
      }
     
			this.$refs.ruleform.validate(valid => {
        if (valid) {
          if (!this.formData.leader_id) {
            this.$message.error("请选择队长");
            return;
          }
          this.$http.post("/api/teams_edit", params).then(res => {
            this.$message.success('保存成功')
            this.getList()
            this.isShowModal = false;
          })
        }
      });
		},
    handlePageChange(e) {
      this.page.current_page = e
      this.getList()
    },
    handleSizeChange(e) {
      this.page.per_page = e
      this.getList()
    },
    changeProject(val, isEdit = false) {
      if (!isEdit) {
        this.formData.leader_id = ""
        this.selectedUsers = []
      }
      this.$http.post('/api/sx_students_list',{pagesize: 1000,project_id: val}).then(res => {
        let data = res.data.data
        let obj = {}
        let deptObj = {}
        data.forEach(item => {
          if (!obj[item.class_name]) {
            obj[item.class_name] = {
              id: item.class_id,
              name: item.class_name,
              children: []
            }
          }
          obj[item.class_name].children.push({
            id: item.id,
            name: item.stu_name
          })

          if (!deptObj[item.class_name]) {
            deptObj[item.class_name] = {
              id: item.class_id,
              dept_name: item.class_name,
              expand: false,
              teachers: []
            }
          }
          deptObj[item.class_name].teachers.push({
            id: item.id,
            username: item.stu_name
          })
        })
        this.members = Object.values(obj)
        this.deptUsers = Object.values(deptObj)
      })
    },
	}
}
</script>
<style scoped lang="less" type="text/less">
.app-container {

	.treeContainer {
		height: 100%;
		background-color: #fff;
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
		border: 1px solid rgba(220, 223, 230, 0.6);
		margin-right: 20px;
		padding-right: 10px;

		.treeTitle {
			height: 40px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			color: #409eff;
			padding-left: 6px;
		}
	}
}

.nodetag {
	display: inline-block;
	padding: 0 5px;
	font-size: 12px;
	transform: scale(0.8, 0.8);
	background-color: #409eff;
	color: #fff;
	border-radius: 4px;
}
</style>
